<section id="fund-literature" class="container">
    <div id="fund-literature_section" *ngIf="!fundLiteratureModel?.is529" (window:resize)="detectScreenSize()">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="rps-heading-two"  id="fund-literature_header">Fund literature</h2>
            </div>
        </div>
        <div class="literature-link">
            <p>
            <a role="link" class="secYieldLink primary-independent" target="_blank" href="{{literatureLink+fundLiteratureModel?.fundId}}">
                View prospectus and reports
                <span  class="hide-text-screenreader-only">
                    Opens a new Window
                </span>
            </a>
            </p>
        </div>
    </div>
</section>
